import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../../hooks/useHasPermission';
import React, { useCallback, useState } from 'react';
import { DeleteRecord } from '../../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useListBackNavigation } from '../../../../hooks/listNavigation';
import { useSelector } from 'react-redux';
import Iconify from '../../../Iconify';
import axios from 'axios';
import '../../../../css/machines/machineDetailsHeader.css';

const MachineReportDetailsHeader = ({ fromMachinePage }) => {

    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { goBack } = useListBackNavigation('/dashboard/controles');
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const machineReportDetailsData = useSelector((state) => state.MachineReportDetailsData);

    const hasMachineReportDeletePermission = useHasPermission('controls_delete');

    const [errMsg, setErrMsg] = useState('');
    const [deleteReport, setDeleteReport] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleDelete = async () => {
        try {
            const response = await axios.delete(`machine-control/${machineReportDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                if (fromMachinePage) {
                    navigate(`/dashboard/machines/machine_details/${machineReportDetailsData.machine_id}`, { state: '3' });
                }
                else {
                    goBack();
                }
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error?.response?.data?.message || 'Erreur lors de la suppression du rapport');
            console.error('Erreur lors de la suppression du rapport :', error);
            CustomErrorLogger(error, 'Erreur lors de la suppression du rapport');
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = useCallback(() => {
        if (fromMachinePage) {
            navigate(`/dashboard/machines/machine_details/${machineReportDetailsData.machine_id}`, { state: '3' });
        }
        else {
            goBack();
        }
    }, [goBack, navigate, machineReportDetailsData.machine_id, fromMachinePage]);

    return (
        <Box className="MachineDetailsHeader_mainBox">
            <Box className="MachineDetailsHeader_firstPart">
                <Iconify className='MachineDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="MachineDetailsHeader_title">Consulter le rapport</Typography>
            </Box>
            <Box className="MachineDetailsHeader_secondPart">
                {(isDesktop && hasMachineReportDeletePermission && !machineReportDetailsData?.machine?.is_archived) &&
                    <Box className="MachineDetailsHeader_action_box" onClick={() => setDeleteReport(true)}>
                        <Iconify className='MachineDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="MachineDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && !machineReportDetailsData?.machine?.is_archived && <Iconify
                    className='MachineDetailsHeader_dots_icon'
                    icon={"vaadin:ellipsis-dots-v"}
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {(!isDesktop && hasMachineReportDeletePermission) &&
                        <MenuItem className='MachineDetailsHeader_menuItem' onClick={() => setDeleteReport(true)}>
                            <Iconify className='MachineDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="MachineDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {deleteReport &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteReport}
                    setOpenDelete={setDeleteReport}
                    handleDelete={handleDelete}
                    title='Êtes-vous sûr de vouloir supprimer ce rapport ?'
                />
            }
        </Box>
    );
}

export default MachineReportDetailsHeader;